/*
 * @providesModule LiveEventPendingPLOW
 *
 */

export default function LiveEventPendingPLOW() {
    return <></>;
}
